import { render, staticRenderFns } from "./ProjCheckList.vue?vue&type=template&id=04a24c5c"
import script from "./ProjCheckList.vue?vue&type=script&lang=js"
export * from "./ProjCheckList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports